<div class="divContainer" style="top:-10px;">

  <div>
    <button type="button" id="btnLoadList" (click)="GetissueData()" style="display:none">Get</button>
    <button type="button" id="btnPopupDT" (click)="issuelistbyid()" style="display:none">Search</button>
    <table #dataTable class="display" style="width:100%" id="tblMainList"></table>
  </div>


  <div id="btnPopupartDetails" class="modal" style="position: fixed !important;display:none">
    <div class="modal-dialog modal-xl custome-modal">
      <div class="modal-content" id="modal_contentArt">
        <div class="modal-header" style="text-align:center">
          <h4 class="modal-title">{{title}}</h4>
          <button type="button" class="close" data-dismiss="modal" (click)="hide()">×</button>
        </div>
        <!--popupbody-->
        <div class="modal-body" style="overflow: hidden !important; position: relative; top: -15px;">
          <table class="tblBkinfo table table-bordered col-4" width="100%" id="tblissuemine">
            <tbody>
              <tr>
                <td>Copy Due Date</td>
                <td>{{CopyDueDate}}</td>
              </tr>
              <tr>
                <td>Issue Make Up</td>
                <td>{{IssueMakeUp}}</td>
              </tr>
              <tr>
                <td>Publication Approved</td>
                <td>{{PublicationApproved}}</td>
              </tr>
              <tr>
                <td>Online Publication</td>
                <td>{{OnlinePublication}}</td>
              </tr>
            </tbody>
          </table>
          <br />
          <!--Table-->
          <div class="row tblissueList col-md-12 fixTableHead">
            <table id="tblissueList" class="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Journal</th>
                  <th>ArticleNo</th>
                  <th>Manuscript</th>
                  <th>ArticleTitle</th>
                  <th>ArticleType</th>
                  <th>Authors</th>
                  <th>AuthorEMail</th>
                  <th>MSPage</th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
          <!--Table end-->
        </div>
        <div class="modal-footer">
          <div class="col-sm-12" style="text-align:right;">
            <button type="button" class="btn btn-outline-danger waves-effect waves-light clsMargin" (click)="hide()">Close</button>&nbsp;&nbsp;&nbsp;
          </div>
        </div>
      </div>
    </div>
    <div id="LoadingImageReopen">
      <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
    </div>
  </div>
</div>
